/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Try_Library_Roleplay_ActionInputs */



/**
* | output |
* | --- |
* | "Go to the practice conversations" |
*
* @param {Nudge_Try_Library_Roleplay_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_try_library_roleplay_action = /** @type {((inputs?: Nudge_Try_Library_Roleplay_ActionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Try_Library_Roleplay_ActionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Naar de oefengesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir les conversations d'entraînement")
	return /** @type {LocalizedString} */ ("Go to the practice conversations")
});